export const homeObjOne = {
    id: 'about',
    lightBG: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'from player parties to grand armies',
    headLine: 'about & commissions',
    description: 'Hello! I’m Bea. I have been playing TTRPG’s for almost 10 years and I loved it whenever the DM would break out a new and exciting mini. The problem was that most of these mini’s lacked what brought them to life…color, shadows, highlights, details. So I gave it a try and had so much fun putting my own spin on the monsters and heroes that we put on the table. I would love to help you bring your games to life too. Currently I am commissioning TTRPG Minis such as player parties or monsters. I can discuss Warhammer and other wargame armies but will probably stay at 1000 points or lower. I can also print custom minis in resin if an stl file is provided. Use the contact form to send me the details of your project and we can discuss pricing.',
    buttonLabel: 'commissions',
    imgStart: true,
    img: require('../../images/aboutphoto.jpg'), //insert your image here
    alt: 'Alt Text',
    dark: true,
    primary: true,
    darkText: true,
    linkTo: "contact",
    hideButton: true,
}


